var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-x":"auto"}},_vm._l((_vm.tree_data),function(data){return _c('ul',{key:data.id,staticClass:"cg-ul"},[_c('CustomerGroup',{attrs:{"data":data}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }